import React, {FC, ReactNode} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {DropdownBoxCoordinator} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {SimpleDropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdownItem';
import {InlineEditingInputDisplay} from './inlineEditingInputDisplay';

/*
 * Types.
 */

interface InlineEditingBooleanPopoverProps {
  onEditSave: (arg: string) => void;
  onEditCancel: () => void;
  value: string;
  shouldStartInEditMode?: boolean;
  customPlaceholder?: ReactNode;
}

/*
 * Style.
 */

/*
 * Component.
 */

export const InlineEditingBooleanPopover: FC<InlineEditingBooleanPopoverProps> = (props) => {
  const {onEditSave, onEditCancel, value, shouldStartInEditMode, customPlaceholder} = props;

  return (
    <InlineEditingInputDisplay>
      <DropdownBoxCoordinator
        value={renderBooleanValue(value) ?? customPlaceholder ?? '-'}
        renderDropdown={(popoverProps) => (
          <SimpleDropdown {...popoverProps} width={popoverProps.anchorWidth}>
            <SimpleDropdownItem key="true" onSelect={() => onEditSave('true')} isChecked={isTrue(value)}>
              {renderBooleanValue('true')}
            </SimpleDropdownItem>
            <SimpleDropdownItem key="false" onSelect={() => onEditSave('false')} isChecked={isFalse(value)}>
              {renderBooleanValue('false')}
            </SimpleDropdownItem>
          </SimpleDropdown>
        )}
        onPopoverToggle={(isPopoverOpen) => {
          // User clicks out without selecting an option
          if (!isPopoverOpen) {
            onEditCancel();
          }
        }}
        isModalInitiallyOpen={shouldStartInEditMode}
        noMargin
        shouldDisablePadding
      />
    </InlineEditingInputDisplay>
  );
};

/*
 * Helpers.
 */

function renderBooleanValue(value: string) {
  if (isTrue(value)) {
    return <Trans id="contact-details-custom-attribute-value-yes">Yes</Trans>;
  }

  if (isFalse(value)) {
    return <Trans id="contact-details-custom-attribute-value-no">No</Trans>;
  }

  return null;
}

function isTrue(value: string) {
  return value === 'true';
}

function isFalse(value: string) {
  return value === 'false';
}
